import { useDispatch, useSelector } from "react-redux";
import { mainActions } from "../../../store";
import classes from "./EarTrainerSetup.module.css";

const EarTrainerRootOctaveSelect = () => {

  const dispatch = useDispatch();

  const earTrainerRootOctaveSelect = useSelector((state) => state.earTrainerRootOctaveSelect);

  const changeHandler = (event) => {
    dispatch(mainActions.setEarTrainerRootOctaveSelect(+event.target.value));
  };

  return (
    <tr>
      <td className={classes.td}>
        <select
          aria-label="Reference root octave"
          value={earTrainerRootOctaveSelect}
          onChange={changeHandler}
          className={classes.select}
        >
          <option value="0">Lowest root</option>
          <option value="1">Highest root</option>
        </select>
      </td>
      <td>Root reference to hear</td>
    </tr>
  );
};

export default EarTrainerRootOctaveSelect;
